import {FACTIONS} from "../../../constants/factions";

export const FENIX_QUOTES = [{
  quote: 'Вы убили меня? Поздравляю. Теперь я злее, быстрее. И у меня есть список',
  author: 'Испепеляющий Крик, пятый феникс этого имени',
  factionId: FACTIONS.FENIX
}, {
  quote: 'Каждый раз, когда я умираю, я забираю с собой вашу надежду. И возвращаюсь с пеплом',
  author: 'Асх-Солнце, легендарный феникс-пироман',
  factionId: FACTIONS.FENIX
}, {
  quote: 'Дракон боится старости. Я — нет. Я боюсь только того, что однажды перестану злиться, когда воскресну',
  author: 'Золотой Уголь, феникс-отшельник',
  factionId: FACTIONS.FENIX
}, {
  quote: 'Умереть — неприятно. Но, воскреснув, снова посмотреть врагу в глаза, того стоит',
  author: 'Солария Новорожденная, феникс Очередного рассвета',
  factionId: FACTIONS.FENIX
}, {
  quote: 'Пепел остывает. Моя злость — нет',
  author: 'Лучезар, феникс Лестницы возгораний',
  factionId: FACTIONS.FENIX
}, {
  quote: 'Каждое воскрешение я теряю частичку себя. Но ненависть — не та частичка, которую я теряю',
  author: 'Фульгур Жестокий, феникс, испепеливший Забытые королевства',
  factionId: FACTIONS.FENIX
}]